import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    ariaLabelForAccountMenu: string;
    accountSwitcherTooltip: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** ARIA label for the account & settings dropdown menu opened from the avatar button */
            ariaLabelForAccountMenu: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountSwitcherMenu.ariaLabelForAccountMenu?c=3rkfxqll4scl3", defaultMessage: "Account and Settings Menu" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip label for the avatar button that opens the account & settings menu */
            accountSwitcherTooltip: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountSwitcherMenu.accountSwitcherTooltip?c=11uhd58i3dpog", defaultMessage: "Account & Settings" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
